module.exports = __webpack_public_path__ + "img/spotify_d5da29cb813555b04fb67ba3bc70ddfd.longcache.png";